import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const downloadElementAsPDF = async (
  elementId: string,
  filename: string,
  padding: number = 10,
): Promise<void> => {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error(`Element with ID "${elementId}" not found.`);
    return;
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    logging: false,
  });

  const imageData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'mm', 'a4');

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const ratio = canvas.width / canvas.height;

  const imgProps = {
    width: pageWidth - 2 * padding,
    height: (pageWidth - 2 * padding) / ratio,
  };

  let position = padding;
  let heightLeft = imgProps.height;

  pdf.addImage(imageData, 'PNG', padding, position, imgProps.width, imgProps.height);

  while (heightLeft > pageHeight - 2 * padding) {
    heightLeft -= pageHeight - 2 * padding;
    position -= pageHeight - 2 * padding;
    pdf.addPage();
    pdf.addImage(imageData, 'PNG', padding, position, imgProps.width, imgProps.height);
  }

  pdf.save(`${filename}.pdf`);
};
